/*eslint-disable */

import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import { bus } from '@/main';

const $ = window.jQuery = require('jquery');  
export default {
  name: 'dashboard-left-sidebar',
  components: {},
  props: [],
  data () {
    return {
      NotificationMsg:'',
      connectionRequest:'',
      supportNotificationMsg:''
    }
  },
  computed: {
  },
  mounted () {
    bus.$on('selfUserUpdateStatus', (data) => {
      if(window.location.pathname.indexOf('workspace') == -1) {
        this.NotificationMsg = data.totalUnreadCount;
      }
      this.connectionRequest = data.connectionRequestCount;
    });
    bus.$on('updateMessageNotifications', (data) => {
      if(window.location.pathname.indexOf('workspace') == -1) {
        if(data.totalUnreadCount > 0){
          if(Push.Permission.has()){
            Push.create(data.senderName, {
              body:data.message,
              timeout:4000,
              onClick: function () {
                  window.focus();
                  this.close();
              }
            })
            this.NotificationMsg = data.totalUnreadCount;
          }else{
            this.NotificationMsg = data.totalUnreadCount;
            this.playSound(audioPlay);
          }
        }
      }
    });
    bus.$on('userFriendRequestClear', (data) => {
      this.connectionRequest = 0;
    });
    bus.$on('clearMessageNotifications', (data) => {
      this.NotificationMsg = 0;
    });
  },
  methods: {
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
  },
  watch:{
  }
}